<template>
  <div class="content container-fluid">
    <!-- Begin: Popover for Filter -->
    <popover
      name="popEmployeeId"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmployeeId"
        :options="colFilter.tranEmployeeIdColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popEmployeeName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEmployeeName"
        :options="colFilter.tranEmployeeNameColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popLeaveName"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranLeaveName"
        :options="colFilter.tranLeaveNameColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popLeaveCalculation"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranLeaveCalculation"
        :options="colFilter.tranLeaveCalculationColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popStartDate"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranStartDate"
        :options="colFilter.tranStartDateColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popEndDate"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranEndDate"
        :options="colFilter.tranEndDateColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <popover
      name="popLeaveDays"
      :pointer="false"
      style="width: 30em; margin-left: -5em"
    >
      <multiselect
        v-model="searchColFilter.tranLeaveDays"
        :options="colFilter.tranLeaveDaysColFilter"
        :multiple="true"
      ></multiselect>
    </popover>
    <!-- End: Popover for Filter -->

    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">{{ type }}</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Guideline -->
    <table class="table table-bordered custom-table">
      <thead class="thead-light">
        <tr>
          <th class="text-center"><h4 class="mb-0">Guideline</h4></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 0 !important">
            <textarea
              class="form-control"
              rows="10"
              readonly
              v-html="guideline"
            >
            </textarea>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- /Guideline -->

    <!-- Filter -->
    <template v-if="type != 'My Leave of Absence'">
      <div class="row align-items-center mt-5">
        <div class="col-md-2 left-title">Company</div>
        <div class="col-md-5 pl-md-0 fit-content">
          <select
            class="custom-select"
            v-model="company"
            @change="getEmployeeLeaves"
          >
            <option
              v-for="(item, i) in companies"
              :key="i"
              :value="item.CompanyName"
            >
              {{ item.CompanyName }}
            </option>
          </select>
        </div>
        <div class="col-md-1"></div>

        <div class="col-md-2 fit-content">Total Days</div>
        <div class="col-md-1 pl-md-0 fit-content">{{ totalDays }}</div>
      </div>
      <div class="row align-items-center mt-2">
        <div class="col-md-2 left-title">Year</div>
        <div class="col-md-3 pl-md-0 fit-content">
          <select
            class="custom-select"
            v-model="year"
            @change="getEmployeeLeaves"
          >
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row align-items-center mt-5">
        <div class="col-md-2 fit-content">Year</div>
        <div class="col-md-3 pl-md-0 fit-content">
          <select
            class="custom-select"
            v-model="year"
            @change="getEmployeeLeaves"
          >
            <option value="">-- Please Select --</option>
            <option v-for="year in years" :key="year" :value="year">
              {{ year }}
            </option>
          </select>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-2 fit-content">Total Days</div>
        <div class="col-md-1 pl-md-0 fit-content">{{ totalDays }}</div>
      </div>
    </template>
    <!-- /Filter -->

    <!-- Pagination -->
    <div class="row" style="margin-top: 30px !important">
      <div class="col-md-6">
        Show
        <select
          class="custom-select"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th v-if="type != 'My Leave of Absence'">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmployeeId
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmployeeId.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('employeeId')">
                    Employee ID
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'employeeId'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'employeeId_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th v-if="type != 'My Leave of Absence'">
                  <i
                    class="fa fa-filter"
                    v-popover:popEmployeeName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEmployeeName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('employeeName')">
                    Employee Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'employeeName'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'employeeName_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popLeaveName
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranLeaveName.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('leaveName')">
                    Leave Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'leaveName'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'leaveName_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popLeaveCalculation
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranLeaveCalculation.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button
                    class="btn p-0"
                    @click="setSortBy('leaveCalculation')"
                  >
                    Leave Calculation
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'leaveCalculation'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'leaveCalculation_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popStartDate
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranStartDate.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('startDate')">
                    Leave Start Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'startDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'startDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popEndDate
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranEndDate.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('endDate')">
                    Leave End Date
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'endDate'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'endDate_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
                <th>
                  <i
                    class="fa fa-filter"
                    v-popover:popLeaveDays
                    v-if="colFilter"
                    :style="[
                      searchColFilter.tranLeaveDays.length > 0
                        ? { color: 'orange' }
                        : { color: 'white' },
                    ]"
                  ></i>
                  <button class="btn p-0" @click="setSortBy('leaveDays')">
                    Leave Days
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'leaveDays'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'leaveDays_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i
                    ></span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in employeeLeaves" :key="i">
                <td v-if="type != 'My Leave of Absence'">
                  {{ item.EmployeeID }}
                </td>
                <td v-if="type != 'My Leave of Absence'">
                  {{ item.EmployeeName }}
                </td>
                <td>{{ item.LeaveName }}</td>
                <td>{{ item.LeaveCalculation }}</td>
                <td>{{ item.LeaveStartDateDisplay }}</td>
                <td>{{ item.LeaveEndDateDisplay }}</td>
                <td>{{ item.LeaveDaysDisplay }}</td>
              </tr>
              <tr v-if="employeeLeaves && !employeeLeaves.length">
                <td
                  :colspan="type == 'My Leave of Absence' ? 5 : 7"
                  class="text-center"
                >
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="employeeLeaves && employeeLeaves.length">
      <div class="col-md-6 col-lg-6 col-sm-6 my-auto text-lg-left text-center">
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          employeeLeaves.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
import Multiselect from "vue-multiselect";

export default {
  props: ["type"],
  components: {
    Multiselect,
  },
  data() {
    return {
      employeeLeaves: null,
      companies: [],
      company: config.DEFAULT_COMPANY,
      years: [],
      year: "",
      totalDays: "0",
      guideline: "",
      noRecordText: config.NO_RECORD_TEXT,
      //for pagination
      searchColFilter: {
        tranEmployeeId: [],
        tranEmployeeName: [],
        tranLeaveName: [],
        tranLeaveCalculation: [],
        tranStartDate: [],
        tranEndDate: [],
        tranLeaveDays: [],
      },
      colFilter: {},
      paging: {
        Search: "",
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 100,
        Sizes: [5, 10, 20, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    isManager() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.IsManager ? data.IsManager : false;
    },
    searchFilter() {
      return [
        { name: "tranEmployeeId", val: this.searchColFilter.tranEmployeeId },
        {
          name: "tranEmployeeName",
          val: this.searchColFilter.tranEmployeeName,
        },
        { name: "tranLeaveName", val: this.searchColFilter.tranLeaveName },
        {
          name: "tranLeaveCalculation",
          val: this.searchColFilter.tranLeaveCalculation,
        },
        { name: "tranStartDate", val: this.searchColFilter.tranStartDate },
        { name: "tranEndDate", val: this.searchColFilter.tranEndDate },
        { name: "tranLeaveDays", val: this.searchColFilter.tranLeaveDays },
      ];
    },
  },

  watch: {
    "searchColFilter.tranEmployeeId": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranEmployeeName": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranLeaveName": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranLeaveCalculation": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranStartDate": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranEndDate": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "searchColFilter.tranLeaveDays": function (val, oldVal) {
      this.getEmployeeLeaves();
    },
    "paging.SizePerPage": function (val, oldVal) {
      this.paging.CurrentPage = 1;
      this.getEmployeeLeaves();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
  },

  methods: {
    getCompanies() {
      let param = {
        Token: this.token,
      };
      this.$store.state.isLoading = true;
      API.getCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getManagerEmployeeCompanies() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      let param = {
        Token: this.token,
        ManagerID: data.EmployeeID,
      };
      this.$store.state.isLoading = true;
      API.getManagerEmployeeCompanies(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.companies = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getYears() {
      let date = new Date();
      let minYear = date.getFullYear() - 2;
      this.years = [];
      for (let year = date.getFullYear(); year > minYear; year--) {
        this.years.push(year);
      }
    },
    getEmployeeLeaves() {
      let param = {
        Token: this.token,
        Search: this.paging.Search,
        CurrentPage: this.paging.CurrentPage,
        TotalPage: this.paging.TotalPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        searchFilter: this.searchFilter,
        Company: this.company,
        Year: this.year,
        Type: this.type,
      };
      this.$store.state.isLoading = true;
      API.getEmployeeLeaves(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.employeeLeaves = response.data.record;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
            this.colFilter = response.data.colFilter;
            this.guideline = response.data.guideline;
            this.totalDays = response.data.totalDays;
            if (this.paging.CurrentPage > this.paging.TotalPage) {
              this.paging.CurrentPage = 1;
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },

    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getEmployeeLeaves();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getEmployeeLeaves();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getEmployeeLeaves();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getEmployeeLeaves();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getEmployeeLeaves();
    },
    setSortBy(payload) {
      switch (payload) {
        case "employeeId":
          if (this.paging.SortBy === "employeeId") {
            this.paging.SortBy = "employeeId_desc";
          } else if (this.paging.SortBy === "employeeId_desc") {
            this.paging.SortBy = "employeeId";
          } else {
            this.paging.SortBy = "employeeId";
          }
          break;
        case "employeeName":
          if (this.paging.SortBy === "employeeName") {
            this.paging.SortBy = "employeeName_desc";
          } else if (this.paging.SortBy === "employeeName_desc") {
            this.paging.SortBy = "employeeName";
          } else {
            this.paging.SortBy = "employeeName";
          }
          break;
        case "leaveName":
          if (this.paging.SortBy === "leaveName") {
            this.paging.SortBy = "leaveName_desc";
          } else if (this.paging.SortBy === "leaveName_desc") {
            this.paging.SortBy = "leaveName";
          } else {
            this.paging.SortBy = "leaveName";
          }
          break;
        case "leaveCalculation":
          if (this.paging.SortBy === "leaveCalculation") {
            this.paging.SortBy = "leaveCalculation_desc";
          } else if (this.paging.SortBy === "leaveCalculation_desc") {
            this.paging.SortBy = "leaveCalculation";
          } else {
            this.paging.SortBy = "leaveCalculation";
          }
          break;
        case "startDate":
          if (this.paging.SortBy === "startDate") {
            this.paging.SortBy = "startDate_desc";
          } else if (this.paging.SortBy === "startDate_desc") {
            this.paging.SortBy = "startDate";
          } else {
            this.paging.SortBy = "startDate";
          }
          break;
        case "endDate":
          if (this.paging.SortBy === "endDate") {
            this.paging.SortBy = "endDate_desc";
          } else if (this.paging.SortBy === "endDate_desc") {
            this.paging.SortBy = "endDate";
          } else {
            this.paging.SortBy = "endDate";
          }
          break;
        case "leaveDays":
          if (this.paging.SortBy === "leaveDays") {
            this.paging.SortBy = "leaveDays_desc";
          } else if (this.paging.SortBy === "leaveDays_desc") {
            this.paging.SortBy = "leaveDays";
          } else {
            this.paging.SortBy = "leaveDays";
          }
          break;
      }
      this.getEmployeeLeaves();
    },
  },

  created() {
    if (this.isManager) this.getManagerEmployeeCompanies();
    else this.getCompanies();

    this.getYears();
    this.getEmployeeLeaves();
  },
};
</script>

<style scoped>
.left-title {
  max-width: 100px;
}

.fit-content {
  max-width: fit-content;
}

textarea {
  background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Leave/LeaveOfAbsence.vue